import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { confirmPasswordReset } from 'firebase/auth';
import { auth } from '../firebase'; // Import the auth object from firebase

const PasswordChange = () => {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const navigate = useNavigate();
  const location = useLocation();

  // Extract the OOB Code from the URL (this is used for password reset)
  const searchParams = new URLSearchParams(location.search);
  const oobCode = searchParams.get('oobCode');

  useEffect(() => {
    if (!oobCode) {
      setError('Invalid password reset link.');
    }
  }, [oobCode]);

  const handleChangePassword = (e) => {
    e.preventDefault();
    setMessage('');
    setError('');

    if (password !== confirmPassword) {
      setError('Passwords do not match.');
      return;
    }

    confirmPasswordReset(auth, oobCode, password)
      .then(() => {
        setMessage('Password changed successfully!');
        navigate('/login'); // Redirect to login page after successful reset
      })
      .catch((error) => {
        setError(error.message); // Display any error from Firebase
      });
  };

  return (
    <div className="max-w-md mx-auto my-10 p-5 border border-gray-300 rounded-lg shadow-lg">
      <h2 className="text-2xl font-semibold text-center">Change Your Password</h2>
      <form onSubmit={handleChangePassword} className="mt-5">
        <div className="mb-4">
          <label htmlFor="password" className="block text-sm font-medium text-gray-700">New Password</label>
          <input
            type="password"
            id="password"
            className="w-full mt-1 p-2 border border-gray-300 rounded-lg"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <div className="mb-4">
          <label htmlFor="confirmPassword" className="block text-sm font-medium text-gray-700">Confirm New Password</label>
          <input
            type="password"
            id="confirmPassword"
            className="w-full mt-1 p-2 border border-gray-300 rounded-lg"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
          />
        </div>
        {message && <div className="text-green-600 text-sm mt-2">{message}</div>}
        {error && <div className="text-red-600 text-sm mt-2">{error}</div>}
        <button
          type="submit"
          className="w-full mt-4 p-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600"
        >
          Change Password
        </button>
      </form>
    </div>
  );
};

export default PasswordChange;
